module.exports = __webpack_public_path__ + "img/bar-l.0c8af7b7.jpg";